import React, {useState, useRef, useEffect} from 'react';

import {
    Modal,
    Popover,
    Tag,
    Empty,
    Segmented,
} from 'antd';

import {
    getLatestNotice, getNoticeByType
} from '../../../../request/api';
import moment from 'moment';

import {AddOperation, NoticeOperation} from "../../../operation";
import {useTranslation} from "react-i18next";

import {
  NoticeItem,
  NoticeListWrapper,
  NoticeMeta,
  TagArea,
  NoticeDate,
  NoticeTitle,
  EmptyText,
  PopoverReset,
  NoticeTitleBar,
  NoticeTitleLeft,
  NoticeMoreBtn,
  ModalBody,
  NoticeListPane,
  Divider,
  ContentPane
} from './style';
import { SegmentedPickerWrapper } from "../../../../common/switchPicker/style";
import { NoticeTypeTag } from '../../../statusTag';
//--------------------------------------------- mock 数据 ---------------------------------------------
// import { mockLatestNotice, mockNoticeByType } from './mock';

// const getLatestNotice = mockLatestNotice;
// const getNoticeByType   = mockNoticeByType;
//--------------------------------------------- mock 数据 ---------------------------------------------
//公告内容HTML处理 防止样式覆盖
const HTMLContentWithLists = ({ item }) => {
  const wrapperRef = useRef(null);

  // 1. 先把 hook 放在顶层
  useEffect(() => {
    if (!wrapperRef.current) return;

    const html = `
      <div style="margin:12px 0;font-size:18px;font-weight:600;color:rgb(0 0 0 /85%);">
        ${item?.title || ''}
      </div>
      <div style="margin-bottom:12px;font-size:14px;color:#999;">
        ${item?.createtime ? moment(item.createtime).format('YYYY-MM-DD HH:mm') : ''}
      </div>
      <div style="font-size: 14px; color: rgb(0 0 0 / 75%);">${item?.content || ''}</div>
    `;

    if (!wrapperRef.current.shadowRoot) {
      wrapperRef.current.attachShadow({ mode: 'open' });
    }
    wrapperRef.current.shadowRoot.innerHTML = html;
  }, [item]);   // item 变化就重写

  // 2. 早期返回写在 hook 后面就安全了
  if (!item) return <div ref={wrapperRef} />;

  return <div ref={wrapperRef} />;
};
const NoticeInfo = () => {

    // 控制 Popover 显隐
    const [popVisible, setPopVisible] = useState(false);
    const [currentType, setCurrentType] = useState(0);   // 0 全部 1 一般 2 重要 3 紧急

    //组件加载后就请求一次数据
    useEffect(() => {
        getLatestNoticeList()
    }, []);

    const {t} = useTranslation();
    //公告弹窗 是否显示
    const [isModalVisible, setIsModalVisible] = useState(false);
    //哪个按钮被点击
    const [clickedButton, setClickedButton] = useState(null);
    //公告鼠标悬浮上去的content内容
    const [notices, setNotices] = useState([]);
    //公告弹窗的列表
    const [noticeList, setNoticeList] = useState([]);
    //当前要显示的公告内容
    const [currentContent, setCurrentContent] = useState('');
    //当前要显示的索引
    const [currentIndex, setCurrentIndex] = useState(null);

    //公告鼠标悬浮上去的title内容
    const noticeTitle = () => {
        return <>
            <NoticeTitleBar>
                <NoticeTitleLeft>{t('All.Operation.notice')}</NoticeTitleLeft>
                {notices && notices.length > 0 && (
                  <NoticeMoreBtn onClick={moreNoticeClickHandler}>
                    {t('All.Operation.more')}
                  </NoticeMoreBtn>
                )}
            </NoticeTitleBar>
        </>
    };

    //更多 按钮点击事件
    const moreNoticeClickHandler = () => {
 
        // 悬浮框关闭
        setPopVisible(false);
        if (isModalVisible) {
            return
        }
        getNoticeList(0)
        setIsModalVisible(true);
    };
    //公告弹窗的四个按钮
    const noticeButtons = () => {
    const options = [
      { label: t('All.Operation.DashboardSwitcher.all'),                  value: 0 },
      { label: t('All.Operation.DashboardSwitcher.NoticeType.urgent'),    value: 3 },
      { label: t('All.Operation.DashboardSwitcher.NoticeType.important'), value: 2 },
      { label: t('All.Operation.DashboardSwitcher.NoticeType.general'),   value: 1 },
    ];

    return (
      <SegmentedPickerWrapper>
        <Segmented
          size="middle"
          className="deviceTypePicker fullWidth"
          value={clickedButton}
          onChange={val => {
            setCurrentType(val);
            getNoticeList(val);
          }}
          options={options}
        />
      </SegmentedPickerWrapper>
    );
  };

    //获取最新的三条公告
    const getLatestNoticeList = () => {
        getLatestNotice().then(res => {
            if (res.status === 200) {
                setNotices(res.data);
            }
        })
    }

    //获取公告列表
    const getNoticeList = (type) => {
        setClickedButton(type)
        getNoticeByType(type).then(res => {
            if (res.status === 200) {
                if (res.data !== null && res.data.length > 0) {
                    setCurrentContent(res.data[0].content);
                    setCurrentIndex(0);
                } else {
                    setCurrentContent('');
                    setCurrentIndex(null);
                }
                setNoticeList(res.data);
            }
        })
    }

    const [hoverIndex, setHoverIndex] = useState(null);
    //enterType 0表示最新三条数据鼠标悬浮 1弹框中公告点击
    const noticeContent = (list, enterType) => {
      return (
      <>
        <NoticeListWrapper>
          {list !== undefined && list.map((item, index) => (    
            <NoticeItem
                key={index}
                onClick={() => {
                  setCurrentIndex(index);          // 点击才“锚定”
                  setCurrentContent(item.content);
                  handleNoticeClick(item, index, item.level);
                }}
                onMouseEnter={() => setHoverIndex(index)}  // 悬浮高亮
                onMouseLeave={() => setHoverIndex(null)}   // 移出取消
                $active={index === hoverIndex}             // 悬浮时和选中时都高亮
                $current={index === currentIndex}
              >
                <NoticeMeta>
                    <TagArea>
                        <NoticeTypeTag level={item.level} createtime={item.createtime} />
                    </TagArea>
                    <NoticeDate>{moment(item.createtime).format('YYYY-MM-DD')}</NoticeDate>
                </NoticeMeta>
                {/* 内容区域 */}
                <NoticeTitle $active={index === hoverIndex}> {item.title} </NoticeTitle>
            </NoticeItem>
          ))}
          {(list === undefined || list.length === 0) && (
            <>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('All.Result.Info.noData')} />
            </>
          )}
        </NoticeListWrapper>
      </>)
    }

    const handleNoticeClick = (item, index) => {
      // 1. 悬浮框关闭
      setPopVisible(false);
      // 2. 不再 setClickedButton(0) ！保持当前按钮高亮
      setClickedButton(currentType);
      // 3. 直接拿当前分组数据
      getNoticeByType(currentType).then(res => {
        if (res.status === 200 && res.data) {
          setNoticeList(res.data);
          // 4. 找到这条公告在当前分组里的索引
          const realIdx = res.data.findIndex(i => i.id === item.id);
          setCurrentIndex(realIdx >= 0 ? realIdx : 0);
          setCurrentContent(item.content);
          setIsModalVisible(true);
        }
      });
    };

    return (
      <>
        <PopoverReset />
          <Popover
            placement="bottom"
            title={noticeTitle}
            content={noticeContent(notices, 0)}
            open={popVisible}                    // 悬浮框受控
            onOpenChange={setPopVisible}         // 同步内部状态
            overlayInnerStyle={{ padding: 0 }}
            zIndex={10000}
            overlayClassName="no-padding-popover"
          >
            <NoticeOperation btnText={t('All.Operation.notice')} type='addPlant'/>
          </Popover>

        { /* 公告弹出框 */
        <Modal
          className='ModalNormal ModalNoticeInfo'
          title={noticeButtons()}
          closable={{'aria-label': 'Custom Close Button'}}
          open={isModalVisible}
          onCancel={() => {
              setIsModalVisible(false);
              // 关闭时重置当前索引(避免下次打开时错误高亮)
              setCurrentIndex(null);
              setCurrentType(0);
          }}
          footer={null}
          zIndex={10000}
        >
          <ModalBody>
            {/* 公告列表 */}
            <NoticeListPane>
              {noticeContent(noticeList, 1, currentIndex)}
            </NoticeListPane>
            <Divider />
            {/*公告内容*/}
            <ContentPane>
              {!noticeList[currentIndex] 
              ? (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('All.Result.Info.noData')}/>) 
              : (<HTMLContentWithLists item={noticeList[currentIndex]} />)}
            </ContentPane>
          </ModalBody>
        </Modal>
        }
    </>
  );
};

export default NoticeInfo;